import { render, staticRenderFns } from "./colorPalette.vue?vue&type=template&id=2a89c93e&scoped=true&"
import script from "./colorPalette.vue?vue&type=script&lang=js&"
export * from "./colorPalette.vue?vue&type=script&lang=js&"
import style0 from "./colorPalette.less?vue&type=style&index=0&id=2a89c93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89c93e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a89c93e')) {
      api.createRecord('2a89c93e', component.options)
    } else {
      api.reload('2a89c93e', component.options)
    }
    module.hot.accept("./colorPalette.vue?vue&type=template&id=2a89c93e&scoped=true&", function () {
      api.rerender('2a89c93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/colorPalette/colorPalette.vue"
export default component.exports